import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "../i18n";
import { ServiceIcon } from "./YuxelServiceIcons";
import { getServiceCatalog } from "../data/yuxelServiceCatalog";
import "./YuxelHomeServices.css";

const CATEGORY_ICONS = {"M01": "Target", "M02": "Fingerprint", "M03": "MousePointerClick", "M04": "Clapperboard", "M05": "Megaphone", "M06": "ShoppingCart", "M07": "GitMerge", "M08": "ChartNoAxesCombined", "A01": "Route", "A02": "ChartLine", "A03": "Receipt", "A04": "Headset", "A05": "GitBranch", "A06": "UserRoundSearch", "A07": "Boxes", "A08": "LayoutDashboard"};

export default function YuxelHomeServices() {
  const { href, lang } = useLang();
  const az = lang === "az";
  const { areas: yuxelServiceAreas, categories: yuxelServiceCategories } = getServiceCatalog(lang);
  return (
    <section id="yx6-home-services" className="yx6-services" lang={lang} aria-label={az ? "YUXEL xidmətləri" : "YUXEL services"}>
      <div className="yx6-wrap">
        <div className="yx6-intro yx6-intro-condensed"><p className="yx6-overline">YUXEL / {az ? "XİDMƏTLƏR" : "SERVICES"}</p><h2>{az ? "Xidmət istiqamətlərimiz" : "Our service areas"}</h2></div>
        {yuxelServiceAreas.map((area, index) => {
          const categories = yuxelServiceCategories.filter(c => area.categoryIds.includes(c.id));
          return <div className="yx6-area" key={area.id} id={`yx6-${area.id}`}>
            <div className="yx6-area-head">
              <div><p className="yx6-area-no">0{index + 1} / {area.label}</p><h3>{area.headline}</h3><p>{area.intro.split("\n\n")[0]}</p></div>
            </div>
            <div className="yx6-grid">
              {categories.map((category,i) => <Link key={category.id} className="yx6-item" to={`${href('/services')}?area=${area.id}#category-${category.id}`}>
                <span className="yx6-item-top"><ServiceIcon name={CATEGORY_ICONS[category.id]} size={32}/><small>{String(i+1).padStart(2,'0')}</small></span>
                <strong>{category.short}</strong>
                <span className="yx6-descr">{category.intro}</span>
                <ArrowUpRight size={17} className="yx6-go" aria-hidden="true"/>
              </Link>)}
            </div>
          </div>;
        })}
      </div>
    </section>
  );
}
